import * as types from './actionTypes';

// ─── Avatar data actions (Ava-Twin SDK) ─────────────────────────────

export const setAvatarLoading = (isLoading) => {
  return {
    type: types.SET_AVATAR_LOADING,
    payload: isLoading,
  };
};

export const setAvatarData = (avatarId, skinToneHex) => {
  return {
    type: types.SET_AVATAR_DATA,
    avatarId,
    skinToneHex,
  };
};

export const forceBroadcast = (broadcast) => {
  return {
    type: types.FORCE_BROADCAST,
    payload: broadcast,
  };
};
